import { useState } from 'react';
import get from 'lodash.get';

import Box from '../Box';
import InfoPanel from './InfoPanel';
import EditForm from './EditForm';

import FmsEnums from 'constants/componentData/fmsEnums';

const PRIMARY = FmsEnums.typeofContact.primary;
const MAILING = FmsEnums.typeofContact.mailing;

const Addresses = props => {
  const { profile, update } = props;
  const [edit, setEdit] = useState(false);
  const { basicInfo: info } = profile || {};

  const getProfile = path => get(profile, path, []) || [];
  const type = typeOf => item => item.typeofContact === typeOf;

  const primary = getProfile('addresses').find(type(PRIMARY)) || {
    typeofContact: PRIMARY,
  };
  const mailing = getProfile('addresses').find(type(MAILING)) || {
    typeofContact: MAILING,
  };

  const onEdit = () => setEdit(true);

  return (
    <Box title="Addresses" onEdit={!edit && onEdit}>
      {edit ? (
        <EditForm
          primary={primary}
          mailing={mailing}
          dbCode={info.dbCode}
          idType={info.idType}
          onCancel={() => setEdit(false)}
          onSave={update}
        />
      ) : (
        <InfoPanel primary={primary} mailing={mailing} />
      )}
    </Box>
  );
};

export default Addresses;
